import {
    IonButton,
    IonContent,
    IonIcon,
    IonPage,
} from "@ionic/react";
import {
    cameraOutline,
} from "ionicons/icons";
import image from "../assets/Instructions/SidePoseInstructions.png";
import "../theme/Instructions.css";
import "../theme/Utilities.css";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { Permissions } from "../components/Permissions";
import SidePoseOverlay from "../components/PoseOverlay";
import PoseOverlay from "../components/PoseOverlay";
const SidePosePage: React.FC = () => {
    const history = useHistory();
    const { profileID,sessionID, gender } = useParams<{profileID:string, sessionID: string; gender: string }>();
    console.log("Rendering SideInstructionsPage", profileID, sessionID);
    const [permission, setPermission] = useState(false);
    useEffect(() => {
      }
      , [permission]);
  
    return (
      <IonPage>
        <IonContent>
            <Permissions updated={(granted: any) => setPermission(granted.gyro)}></Permissions>

          {permission && (
            <>
            
            <div className="flex items-center justify-center mt-16">
             {/*  <img
                src={image}
                alt="Person in an A-pose"
                className="max-h-[70vh] max-w-full w-auto h-auto"
              /> */}
              <PoseOverlay view="side" />
              </div>


  
              <div className="buttonsUnderInstructions">
                <IonButton
                  size="large"
                  fill="outline"
                  onClick={() => history.push(`/photo/${profileID}/${sessionID}/${gender}/right`)}
                >
                  Open camera <IonIcon icon={cameraOutline} />
                </IonButton>
              </div>
            </>
          )}
        </IonContent>
      </IonPage>
    );
  };

export default SidePosePage;
